import React from "react";

//styles
import styles from "./TableCell.module.scss";
import cx from "classnames";
import useWindowDimensions from "../../../../common/hooks/useWindowDimensions";

export interface ITableCellProps {
    className?: string;
    isHeader?: boolean;
    size?: "small" | "medium" | "large" | "auto";
    alignContent?: "left" | "center";
}

const TableCell: React.FC<ITableCellProps> = (props) => {
    const { isHeader, size, children } = props;

    const { isTabletPortrait } = useWindowDimensions();

    const Component = isHeader ? "th" : "td";
    const alignContent: ITableCellProps["alignContent"] = props.alignContent || "left";

    return (
        <Component
            className={cx([
                styles["table-cell"],
                {
                    // Font size
                    ["text-font-size-xs"]: isTabletPortrait,
                    ["text-font-size-s"]: !isTabletPortrait,
                    // Weight
                    ["text-bold"]: isHeader,
                    ["text-no-bold"]: !isHeader,
                    // Size
                    [styles["table-cell__small"]]: size === "small",
                    [styles["table-cell__medium"]]: size === "medium",
                    [styles["table-cell__large"]]: size === "large",
                    // Align Content
                    ["layout-flex-row--start"]: alignContent === "left",
                    ["layout-flex-row--centered"]: alignContent === "center",
                    // Custom
                    [props.className]: !!props.className
                }
            ])}>
            {children}
        </Component>
    );
};

export default TableCell;
